import React, { useMemo } from "react";
import CardActionArea from "@material-ui/core/CardActionArea";
import { NavLink, useHistory } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import noImg from "../../../asset/noImage.jpg";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Button from "@material-ui/core/Button";


const ObjectCard = (props) => {
  const { id, active, name, image, paymentType, baseUrl, children } = props
  let history = useHistory()

  let path = history.location.pathname

  const isActive = useMemo(() => active === "Y", [active]);
  const lockObject = useMemo(() => paymentType === 'free' && isActive, [isActive, paymentType])

  const paymentTypeChip = useMemo(() => {
    if (lockObject) return

    return paymentType === "percent"
      ? isActive && <Chip label="Комиссионный" size="small" className="badge commission"/>
      : isActive && <Chip label="Абонентский" size="small" className="badge subscriber"/>
  }, [isActive, paymentType])

  const activityTypeChip = useMemo(() => {
    if (lockObject) return <Chip label="На проверке" size="small" className="badge disabled"/>

    return isActive
      ? <Chip label="Активен" size="small" className="badge active"/>
      : <Chip label="Неактивен" size="small" className="badge deactive"/>


  }, [isActive, lockObject])


  const cardSwitchType = (path, id) => {

    switch (true) {
      case (path.includes("busy-calendar")): {
        return { title: "Занятость", link: `/lk/busy-calendar/${id}`, classes: 'card-object ' }
      }

      case path.includes("booking"): {
        return { title: "Бронирования", link: `/lk/booking/${id}`, classes: 'card-object ' }
      }
      case path.includes("reviews"): {
        return { title: "Отзывы", link: `/lk/reviews/${id}`, classes: 'card-object ' }
      }

      case path.includes("invoices"): {
        return { title: "Счета", link: `/lk/invoices/${id}`, classes: 'card-object ' }
      }
      case path.includes("access-right"): {
        return {
          title: "Добавить пользователя",
          link: `/lk/access-right/detail/${id}`,
          classes: 'card-object card-access'
        }
      }
      default: {
        return { title: "Смотреть/изменить", link: `/lk/${id}`, classes: 'card-object ' }
      }

    }

  }

  return (<div className="col">

    <CardActionArea className="h-100" component={NavLink} to={cardSwitchType(path, id).link} disabled={lockObject}>
      <Card className={`card h-100 ${cardSwitchType(path, id).classes}`}>
        <CardMedia
          component="img"
          alt=""
          className="card-img"
          image={image ? baseUrl + image : noImg}
          title=""
          style={!image ? { objectFit: "contain" } : null}
        />
        <CardContent className={"card-body"}>
          <Box component="div" textOverflow="ellipsis">
            <Typography component="h6" variant="h6" className={"title"} noWrap>
              {name}
            </Typography>
          </Box>
          <Box className={"mb-auto"}>
            {paymentTypeChip}
            {activityTypeChip}
          </Box>

          {children}

        </CardContent>

        <Button className="card-object__btn" color="primary">

          {cardSwitchType(path, id).title}
        </Button>

      </Card>
    </CardActionArea>

  </div>)
}

export default ObjectCard
